import { render, staticRenderFns } from "./dialPhone.vue?vue&type=template&id=dda55bc0"
import script from "./dialPhone.vue?vue&type=script&lang=js"
export * from "./dialPhone.vue?vue&type=script&lang=js"
import style0 from "./dialPhone.vue?vue&type=style&index=0&id=dda55bc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports